/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

export const getBabelfishConnection = (username: string, host: string, port: string | number) =>
  `mssql://${username}@${host}:${port}`;
